import React from 'react';
import './Landing.scss';
import { Button } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import Manual from 'component/Manual';

function Landing(): JSX.Element {
  const history = useHistory();
  return (
    <section className="page landing-page">
      <Manual />
      <Button
        variant="outlined"
        className="landing-button"
        color="primary"
        onClick={() => history.push('/list')}
      >
        시작하기
      </Button>
    </section>
  );
}

export default Landing;
